import { createDomain } from 'effector-root';

const domain = createDomain('Users (Page)');

export const onPageStarted = domain.event();